import React, {Component} from "react";
import {Col, Row, Table} from "react-bootstrap";
import ReceiptExchange from "./ReceiptExchange";
import ReceiptExchangeRemove from "./ReceiptExchangeRemove";

export default class ReceiptExchangeList extends Component {

    state = {
        exchanges: [],
        // Keep UI/UX consistent with InvalidReceiptList
        currentPage: 1,
        pageSize: 50,
        searchName: ''
    }

    refreshExchanges = () => {
        const applyList = (list) => this.setState({exchanges: Array.isArray(list) ? list : []});

        fetch('/rest/exchanges')
            .then(res => res.ok ? res.json() : Promise.reject())
            .then((result) => {
                applyList(Array.isArray(result) ? result : []);
            })
            .catch(() => applyList([]));
    }

    componentDidMount() {
        this.refreshExchanges();
    }

    modalHandler = (exchange) => {
        if (this.state.exchangeModal != null) {
            this.setState({
                exchangeModal: undefined
            })
        } else {
            this.setState({
                exchangeModal: (
                    <ReceiptExchange onClose={this.modalHandler} onChange={this.refreshExchanges} exchange={exchange}/>)
            })
        }
    }

    deleteHandler = (exchange) => {
        if (this.state.exchangeModal != null) {
            this.setState({
                exchangeModal: undefined
            })
        } else {
            this.setState({
                exchangeModal: (<ReceiptExchangeRemove onClose={this.modalHandler} onChange={this.refreshExchanges}
                                                       exchange={exchange}/>)
            })
        }
    }

    render() {

        // Derived filtered + paginated list — search by name only
        const nameQ = (this.state.searchName || '').trim().toLowerCase();
        const matches = (v, q) => (v ?? '').toString().toLowerCase().includes(q);

        const filtered = (Array.isArray(this.state.exchanges) ? this.state.exchanges : []).filter(ex => {
            const okName = nameQ ? matches(ex?.name, nameQ) : true;
            return okName;
        });

        const total = filtered.length;
        const totalPages = Math.max(1, Math.ceil(total / this.state.pageSize));
        const page = Math.min(this.state.currentPage, totalPages);
        const start = (page - 1) * this.state.pageSize;
        const pageItems = filtered.slice(start, start + this.state.pageSize);

        return (
            <div className={'container-xxl mt-3'}>
                {this.state.exchangeModal || ''}

                <Row className="align-items-center mb-1">
                    <Col lg={7} className={'d-flex gap-2 flex-wrap'}>
                        <div className="search-wrap" style={{flex: 1}}>
                            <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z"
                                      stroke="#8C99A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Нэр"
                                value={this.state.searchName}
                                onChange={(e) => this.setState({searchName: e.target.value, currentPage: 1})}
                            />
                        </div>
                    </Col>
                    <Col lg={5} className={'text-end'}>
                        <button className="btn btn-primary border"
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px', margin: 2}}
                                onClick={() => this.refreshExchanges()}>Шинэчлэх
                        </button>
                        <button className={'btn btn-primary border'}
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px', margin: 2}}
                                onClick={() => this.modalHandler(null)}>Нэмэх
                        </button>
                    </Col>
                </Row>

                <div className="p-2 mb-0 merchant-table-wrapper">
                    <div className="merchant-table-area">
                        <Table striped={false}
                               className={'table table-borderless align-middle merchant-table table-compact'}>
                            <thead>
                            <tr>
                                <th width={80}>Order</th>
                                <th>Нэр</th>
                                <th width={200}>Code</th>
                                <th width={200}>Төрөл</th>
                                <th width={100}>Status</th>
                                <th width={120}>Time Out</th>
                                <th>URL</th>
                                <th width={150}>Үйлдэл</th>
                            </tr>
                            </thead>
                            <tbody>
                            {pageItems.length > 0 ? pageItems.map(exchange => (
                                <tr key={exchange.order}>
                                    <td className={'align-middle'}>{exchange.order}</td>
                                    <td className={'align-middle'}>{exchange.name}</td>
                                    <td className={'align-middle'}>{exchange.code}</td>
                                    <td className={'align-middle'}>{exchange.type}</td>
                                    <td className={'align-middle'}>{exchange.status}</td>
                                    <td className={'align-middle'}>{exchange.timeOut}</td>
                                    <td className={'align-middle'}>{exchange.exchangeUrl}</td>
                                    <td className={'align-middle'}>
                                        <button className={'btn btn-primary btn-sm me-1 border'}
                                                style={{backgroundColor: '#2C6A8C', borderRadius: '8px', margin: 2}}
                                                onClick={() => this.modalHandler(exchange)}>Засах
                                        </button>
                                        <button className={'btn btn-danger btn-sm border'}
                                                style={{backgroundColor: '#2C6A8C', borderRadius: '8px', margin: 2}}
                                                onClick={() => this.deleteHandler(exchange)}>Устгах
                                        </button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={8} className="text-center text-muted">Мэдээлэл олдсонгүй</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>

                    {total > 0 && (
                        <div className="pagination-bar">
                            <div className="text-muted small">Нийт: {total}</div>
                            <div className="d-flex align-items-center gap-2">
                                <button className="page-btn"
                                        onClick={() => this.setState({currentPage: Math.max(1, this.state.currentPage - 1)})}
                                        disabled={page === 1}>‹
                                </button>
                                {(() => {
                                    const items = [];
                                    for (let i = 1; i <= totalPages; i++) {
                                        items.push(
                                            <button key={`pg_${i}`}
                                                    className={`page-btn ${page === i ? 'active' : ''}`}
                                                    onClick={() => this.setState({currentPage: i})}>{i}</button>
                                        );
                                    }
                                    return items;
                                })()}
                                <button className="page-btn"
                                        onClick={() => this.setState({currentPage: Math.min(totalPages, this.state.currentPage + 1)})}
                                        disabled={page === totalPages}>›
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}